import React from 'react'

export const ApprovalReportData = (props) => {
    const{showList,styles} = props
  return (
    <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                                    style={styles}>
                                    <thead >
                                        <tr>
                                            <th>S.NO</th>
                                            <th>Current No.</th>
                                            <th>Organisation Name</th>
                                            <th>LR No. & Date</th>
                                            <th >Dept </th>
                                            <th >Work Executed at</th>
                                            <th>Date of Recieving</th>
                                            <th>By Dept / Extl</th>
                                            <th>Name of Bank</th>
                                            <th>Branch</th>
                                            <th>DD /Cheque</th>
                                            <th>cheque No. /DD No.</th>
                                            <th>Date</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {showList.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item?.current_no}</td>
                                                <td>{item.organisation_name}</td>
                                                <td>{item.lr_no_and_date}</td>
                                                <td>{item.dept}</td>
                                                <td>{item.work_executed_at_district_name}</td>
                                                <td>{item.date_of_recieving}</td>
                                                <td>{item.by_dept}</td>
                                                <td>{item.name_of_bank}</td>
                                                <td>{item.branch}</td>
                                                <td>{item.dd_cheque}</td>
                                                <td>{item.cheque_no_or_ddno}</td>
                                                <td>{item.date}</td>
                                                <td>{item.amount}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
    <tr>
        <td colSpan={12}></td>
        <td>Total</td>
        <td>
        {showList.reduce(
                          (a, v) => (a = a + v.amount),
                          0
                        )}
        </td>
    </tr>
</tfoot>
                                </table>
  )
}
